import { Box, Typography, useTheme } from "@mui/material";
import { ForwardedRef, forwardRef } from "react";
import Boxoutline from "../../../../../../media/images/icons/outline-box";
import StarSpeed from "../../../../../../media/images/icons/star-speed";
import BigCarSpeed from "../../../../../../media/images/icons/bigcar-speed";
import DolorGreen from "../../../../../../media/images/icons/dolor-green";
import BigCarIcon2 from "../../../../../../media/images/icons/big-car-2";
import ArrowStepLeft from "../../../../../../media/images/icons/arrow-steps-register";
import LocationFill from "../../../../../../media/images/icons/location-fill";
import FerightDetails from "./Details";
import { addCommas } from "@persian-tools/persian-tools";
import { blueGrey } from "@mui/material/colors";
import { IOrder } from "../../../../../../types/driver";

const CargoCard = forwardRef((props: IOrder, ref: ForwardedRef<HTMLDivElement>) => {
  const theme = useTheme();
  const { index, goodsName, loaderTypeGroup, fare, source, destination, orderId, truckCount,orderCarryType } = props;

  return (
    <Box
      ref={ref}
      sx={{
        boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
        display: "flex",
        borderColor: blueGrey[100],
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: "16px",
        flexDirection: "column",
        padding: "8px",
        backgroundColor: "bgColor.white",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "4px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "bgColor.blueGrey50",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "6px",
            borderRadius: "8px",
          }}
        >
          <Boxoutline color={theme.palette.textColor.main} />
        </Box>

        <Box
          sx={{
            flex: "1",
            // border: "1px solid gray",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <Typography
              sx={{
                fontWeight: "600",
              }}
            >
              {goodsName}
            </Typography>
            <Box
              sx={{
                // border: "1px solid gray",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              {/* <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: theme.palette.secondary[50],
                    padding: "4px",
                    borderRadius: "6px",
                    gap: "3px",
                  }}
                >
                  <StarSpeed size={16} color={theme.palette.secondary.main} />

                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "secondary.main",
                    }}
                  >
                    جدید
                  </Typography>
                </Box> */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: theme.palette.primary[50],
                  padding: "4px",
                  borderRadius: "6px",
                  gap: "4px",
                }}
              >
                <BigCarSpeed size={16} color={theme.palette.primary.main} />

                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "primary.main",
                  }}
                >
                  {truckCount} ناوگان درخواستی
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: theme.palette.primary[50],
                padding: "4px",
                borderRadius: "8px",
                gap: "4px",
              }}
            >
              <BigCarIcon2 color={theme.palette.primary.main} />
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "700",
                  color: "primary.main",
                }}
              >
                {loaderTypeGroup}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "success.light",
                padding: "4px",
                borderRadius: "6px",
              }}
            >
              <DolorGreen color={theme.palette.success.main} />
              <Typography
                sx={{
                  color: "success.main",
                }}
              >
                {addCommas(fare)} ریال
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: theme.palette.bgColor.grey100,
          paddingY: "8px",
          paddingX: "4px",
          borderRadius: "8px",
          borderColor: blueGrey[100],
          borderWidth: "1px",
          borderStyle: "solid",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flex: 1,
            justifyContent: "center",
          }}
        >
          <LocationFill size={22} color={theme.palette.primary.main} />
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            {source}
          </Typography>
        </Box>
        <ArrowStepLeft color={theme.palette.textColor.main} />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flex: 1,
            gap: "4px",
            justifyContent: "center",
          }}
        >
          <LocationFill size={22} color={theme.palette.secondary.main} />
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            {destination}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: theme.palette.primary[50],
          padding: "4px",
          borderRadius: "6px",
          gap: "4px",
        }}
      >
        <BigCarSpeed size={16} color={theme.palette.primary.main} />

        <Typography
          sx={{
            fontSize: "12px",
            color: "primary.main",
          }}
        >
          {orderCarryType}
        </Typography>
      </Box>
      <FerightDetails {...props} />
    </Box>
  );
});

export default CargoCard;
